import { Injectable } from '@angular/core';
import { AppCollection } from '../../app.config';
import { BaseCollectionService } from '../../core/jsonApi/BaseCollectionService';
import { LearningSectionContainerJsonModel } from './learning-section-container.json.model';

@Injectable({
  providedIn: 'root'
})
export class LearningSectionContainerService extends BaseCollectionService<LearningSectionContainerJsonModel, AppCollection> {
  protected ctor = LearningSectionContainerJsonModel;
}
